const TiposTelefoneValues = [
  {
    label: "Telefone Fixo",
    telefone_fixo: true
  },
  {
    label: "Telefone Celular",
    telefone_fixo: false
  }
];

export {TiposTelefoneValues};
